export const visit = (vm, at) => {
at({ "fr": { "pricingPage": { "detailedTermSelector": { "payMonthly": "Paiement mensuel", "payAnnually": "Paiement annuel", "commitMonthly": "Engagement mensuel", "commitAnnually": "Engagement annuel", "bestValue": "Meilleure offre" } } } });
};